import React, { Component } from 'react'
import cover from '../../assets/img/cover.png'
import dp from '../../assets/img/dp.png'
import './Profile.css'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

class Profile extends Component {
    state={
        userProfile:{
            id:"0123456789",
            name:"Sandeep Mandal",
            phone:"8083717128",
            address:"St college Japla",
            dob:"25-Oct-1997",
            email:"example@gmail.com",
        }
    }
    render() {
        let picStyle = {
            backgroundColor: "red",
            width: "100px",
            height: "100px",
            borderRadius: "45px"
        }
        return (<div>
            {/* <div style={{ width: "100%", backgroundColor: "grey" }}>
                <div style={picStyle}>

                </div>
            </div>
            <h3>Name :{this.state.userProfile.name}</h3>
            <h5>Roll No :{this.state.userProfile.roll}</h5>
            <h5>Class :{this.state.userProfile.classes}</h5>
            <h5>Parent :{this.state.userProfile.parent}</h5>
            <h5>Address :{this.state.userProfile.address}</h5>
            <h5>Phone No: {this.state.userProfile.Phone}</h5> */}
            <div className="row">
                <div className="col-lg-6">
                    <div className="row">
                        <div className="col">
                            <div className="cover" style={{ backgroundImage: "url(" + cover + ")" }}>
                            </div>
                            <div>
                                <div className="detail" style={{ backgroundImage: "url(" + dp + ")" }}>

                                </div>
                                <div style={{ float: "right", paddingLeft: "20px" }}>
                                    <h1>{this.state.userProfile.name}</h1>
                                    <strong>Admission No : {this.state.userProfile.id}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="card">
                                <table style={{ margin: "5%" }}>
                                    <tbody>
                                        <tr>
                                            <td>USERNAME</td>
                                            <td>{this.state.userProfile.name}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td>{this.state.userProfile.phone}</td>
                                        </tr>
                                        <tr>
                                            <td>Address</td>
                                            <td>{this.state.userProfile.address}</td>
                                        </tr>
                                        <tr>
                                            <td>Date of Birth</td>
                                            <td>{this.state.userProfile.dob}</td>
                                        </tr>
                                        <tr>
                                            <td>Mother's Name</td>
                                            <td>{this.state.userProfile.motherName}</td>
                                        </tr>
                                        <tr>
                                            <td>Father's Name</td>
                                            <td>{this.state.userProfile.parent}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            Personal Information
                    </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <label>Name</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.name} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>Username</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.name} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <label>Email</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.email}
                                            aria-label="Username" aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>Phone</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.phone} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <label>Address</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.address}
                                            aria-label="Username" aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>Date of Birth</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.dob} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>Father's Name</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.parent}
                                            aria-label="Username" aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>Mother's Name</label>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">@</span>
                                        </div>
                                        <input type="text" className="form-control" onChange={() => console.log("On change")} value={this.state.userProfile.motherName} aria-label="Username"
                                            aria-describedby="basic-addon1" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>


        </div>);
    }
}
// const Student = (props) => {

// }
export default Profile;